
  
  import { runInjectionScript, swapDocument } from "@clerk/astro/internal";

  // Taken from https://github.com/withastro/astro/blob/e10b03e88c22592fbb42d7245b65c4f486ab736d/packages/astro/src/transitions/router.ts#L39.
  // Importing it directly from astro:transitions/client breaks custom client-side routing
  // even when View Transitions is disabled.
  const transitionEnabledOnThisPage = () => {
    return !!document.querySelector('[name="astro-view-transitions-enabled"]');
  }

  if (transitionEnabledOnThisPage()) {
    // Start loading eagerly without awaiting so both listeners share one module load.
    // Listeners are registered synchronously here, which avoids the race where awaiting
    // before addEventListener would cause us to miss the initial astro:page-load event.
    const transitionClient = import('astro:transitions/client');

    document.addEventListener('astro:before-swap', async (e) => {
      const nextDocument = e.newDocument;
      const nextHead = nextDocument?.head;
      if (!nextDocument || !nextHead) {
        return;
      }

      const { swapFunctions } = await transitionClient;

      e.swap = () => {
        const clerkComponents = document.querySelector('#clerk-components');
        // Move (not clone) the element so Clerk's React root stays bound to its host node
        // across the body swap. Cloning produces a detached copy with no React associated,
        // which breaks style injection on subsequent navigations.
        if (clerkComponents) {
          nextDocument.body.appendChild(clerkComponents);
        }
        swapDocument(swapFunctions, nextDocument);
      };
    });

    document.addEventListener('astro:page-load', async (e) => {
      const { navigate } = await transitionClient;

      await runInjectionScript({
        ...{"sdkMetadata":{"version":"3.4.17","name":"@clerk/astro","environment":"production"}},
        routerPush: navigate,
        routerReplace: (url) => navigate(url, { history: 'replace' }),
      });
    });
  } else {
    await runInjectionScript({"sdkMetadata":{"version":"3.4.17","name":"@clerk/astro","environment":"production"}});
  }